import ApplicationController from './application_controller'
import SlimSelect from 'slim-select'
import 'slim-select/styles'

export default class extends ApplicationController {
    static targets = ['select']

    connect () {
      console.log(this.selectTarget)

      if (this.hasSelectTarget) {
        this.select = this.fillSelect()
      }
    }

    fillSelect () {
      console.log(this.selectTarget)

      this.selectTarget.classList.remove('form-control')
      return new SlimSelect({
        select: this.selectTarget,
        placeholder: this.selectTarget.dataset.placeholder
      })
    }
}
